import _ from 'lodash';
import {connect} from 'react-redux';

import {
  AppParametricSelector,
  createSelector,
  makeMapStateToProps,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {MessageModel} from '../../../models/api/messageModel';
import {getMessages} from '../../../store/data/dataSelectors';
import {makeGetMessagesSelection} from '../../../store/panels/cells/selectors/cellsPanelSelectionSelectors';
import {InboxesTeammateMessagesParameters} from '../../../store/panels/inboxes/parameters/inboxesParameters';
import {CellsPanelId} from '../../../store/panels/panelStateBase';
import {MessageCellDragSource} from './messageCellDragSource';

/*
 * Props.
 */

interface MessageCellDragSourceContainerProps {
  panelId: CellsPanelId;
  parameters: InboxesTeammateMessagesParameters;
  message: MessageModel;
  isSelected?: boolean;
}

/*
 * Selectors.
 */

function getCellsPanelId(_state: unknown, props: MessageCellDragSourceContainerProps) {
  return props.panelId;
}

function getParameters(_state: unknown, props: MessageCellDragSourceContainerProps) {
  return props.parameters;
}

function makeGetSelectedMessages(): AppParametricSelector<
  MessageCellDragSourceContainerProps,
  ReadonlyArray<MessageModel>
> {
  return createSelector(
    [getMessages, makeGetMessagesSelection(getParameters, getCellsPanelId)],
    (messages, messagesSelection) =>
      _(messagesSelection.knownIds)
        .map((uid) => messages[uid])
        .compact()
        .value(),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MessageCellDragSourceContainerProps>()(() => ({
  selectedMessages: makeGetSelectedMessages(),
}));

export const MessageCellDragSourceContainer = connect(mapStateToProps)(MessageCellDragSource);
